/**
 * @fileoverview gRPC-Web generated client stub for fleet
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as station_pb from './station_pb';

import {
  AutocompletePredictionsRequest,
  AutocompletePredictionsResponse,
  DirectionsRequest,
  DirectionsResponse,
  PlaceDetailsFromLatLngRequest,
  PlaceDetailsRequest,
  PlaceDetailsResponse} from './places_pb';

export class PlacesServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetAutocompletePredictions = new grpcWeb.AbstractClientBase.MethodInfo(
    AutocompletePredictionsResponse,
    (request: AutocompletePredictionsRequest) => {
      return request.serializeBinary();
    },
    AutocompletePredictionsResponse.deserializeBinary
  );

  getAutocompletePredictions(
    request: AutocompletePredictionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<AutocompletePredictionsResponse>;

  getAutocompletePredictions(
    request: AutocompletePredictionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AutocompletePredictionsResponse) => void): grpcWeb.ClientReadableStream<AutocompletePredictionsResponse>;

  getAutocompletePredictions(
    request: AutocompletePredictionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: AutocompletePredictionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.PlacesService/GetAutocompletePredictions',
        request,
        metadata || {},
        this.methodInfoGetAutocompletePredictions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.PlacesService/GetAutocompletePredictions',
    request,
    metadata || {},
    this.methodInfoGetAutocompletePredictions);
  }

  methodInfoGetPlaceDetails = new grpcWeb.AbstractClientBase.MethodInfo(
    PlaceDetailsResponse,
    (request: PlaceDetailsRequest) => {
      return request.serializeBinary();
    },
    PlaceDetailsResponse.deserializeBinary
  );

  getPlaceDetails(
    request: PlaceDetailsRequest,
    metadata: grpcWeb.Metadata | null): Promise<PlaceDetailsResponse>;

  getPlaceDetails(
    request: PlaceDetailsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: PlaceDetailsResponse) => void): grpcWeb.ClientReadableStream<PlaceDetailsResponse>;

  getPlaceDetails(
    request: PlaceDetailsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: PlaceDetailsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.PlacesService/GetPlaceDetails',
        request,
        metadata || {},
        this.methodInfoGetPlaceDetails,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.PlacesService/GetPlaceDetails',
    request,
    metadata || {},
    this.methodInfoGetPlaceDetails);
  }

  methodInfoGetDirections = new grpcWeb.AbstractClientBase.MethodInfo(
    DirectionsResponse,
    (request: DirectionsRequest) => {
      return request.serializeBinary();
    },
    DirectionsResponse.deserializeBinary
  );

  getDirections(
    request: DirectionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<DirectionsResponse>;

  getDirections(
    request: DirectionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: DirectionsResponse) => void): grpcWeb.ClientReadableStream<DirectionsResponse>;

  getDirections(
    request: DirectionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: DirectionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.PlacesService/GetDirections',
        request,
        metadata || {},
        this.methodInfoGetDirections,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.PlacesService/GetDirections',
    request,
    metadata || {},
    this.methodInfoGetDirections);
  }

  methodInfoGetPlaceDetailsFromLatLng = new grpcWeb.AbstractClientBase.MethodInfo(
    PlaceDetailsResponse,
    (request: PlaceDetailsFromLatLngRequest) => {
      return request.serializeBinary();
    },
    PlaceDetailsResponse.deserializeBinary
  );

  getPlaceDetailsFromLatLng(
    request: PlaceDetailsFromLatLngRequest,
    metadata: grpcWeb.Metadata | null): Promise<PlaceDetailsResponse>;

  getPlaceDetailsFromLatLng(
    request: PlaceDetailsFromLatLngRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: PlaceDetailsResponse) => void): grpcWeb.ClientReadableStream<PlaceDetailsResponse>;

  getPlaceDetailsFromLatLng(
    request: PlaceDetailsFromLatLngRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: PlaceDetailsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.PlacesService/GetPlaceDetailsFromLatLng',
        request,
        metadata || {},
        this.methodInfoGetPlaceDetailsFromLatLng,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.PlacesService/GetPlaceDetailsFromLatLng',
    request,
    metadata || {},
    this.methodInfoGetPlaceDetailsFromLatLng);
  }

}

